/********************************************************************************
 * Copyright (c) 2021 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import JSG from '@cedalo/jsg-ui';

const getSheetModel = (item) => {
	if (item instanceof JSG.StreamSheetModel) return item.sheet;
	if (item instanceof JSG.StreamSheetContainer) return item.getStreamSheet().model;
	if (item instanceof JSG.InboxContainer) return item.getStreamSheet().model;
	return undefined;
};
export class UpdateCustomInfosCommand extends JSG.RequestCommand {
	constructor(item, cmd, getInfos) {
		super(getSheetModel(item));
		this.item = item;
		this.orgcmd = cmd;
		this.getInfos = getInfos;
	}

	// overwritten since it is allowed to not provide a sheet!
	get sheet() {
		return this._sheet;
	}

	customInfos(item) {
		return item ? { infos: this.getInfos(item) } : { infos: [] };
	}

	getExecuteRequest() {
		this.orgcmd.execute();
		return this.createRequest(this.customInfos(this.item));
	}
	getRedoRequest() {
		this.orgcmd.redo();
		return this.createRequest(this.customInfos(this.item));
	}
	getUndoRequest() {
		this.orgcmd.undo();
		return this.createRequest(this.customInfos(this.item));
	}

	handleError(error, type) {
		super.handleError(error);
		if (type === 'execute' || type === 'redo') this.orgcmd.undo();
		else this.orgcmd.redo();
	}
	handleResult(/* result */) {}
}
// export class UpdateCustomInfosCompoundCommand extends JSG.CompoundRequestCommand {
// 	add(cmd) {
// 		return cmd.name === 'command.server.UpdateCustomInfosCommand' ? super.add(cmd) : this;
// 	}
// }
